var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.06,
    height: 56.06,
    viewBox: "0 0 56.06 56.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13263",
    "data-name": "Group 13263",
    transform: "translate(-393.106 -3418.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    transform: "translate(393.106 3418.14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 28.03,
    cy: 28.03,
    rx: 28.03,
    ry: 28.03,
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "youtube-outline-svgrepo-com",
    d: "M26.871,4.607A3.637,3.637,0,0,1,29.44,7.175a37.993,37.993,0,0,1,.607,6.992,37.773,37.773,0,0,1-.607,6.991,3.637,3.637,0,0,1-2.568,2.568c-2.264.607-11.348.607-11.348.607s-9.084,0-11.348-.607a3.637,3.637,0,0,1-2.568-2.568A37.773,37.773,0,0,1,1,14.167a37.774,37.774,0,0,1,.607-6.992A3.638,3.638,0,0,1,4.175,4.607C6.44,4,15.523,4,15.523,4S24.607,4,26.871,4.607Zm-6.709,9.56-7.546,4.357V9.811Z",
    transform: "translate(406.404 3431.319)",
    fill: "none",
    stroke: "#04253d",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.585a7cc70681eaa28ebb1eac255f417a.svg";
export { ForwardRef as ReactComponent };